import { useId } from 'react';

export const useAutoId = (userInputId?: string): string => {
  const tempId = useId();
  return userInputId || `auto-id-${tempId}`;
};

export default useAutoId;
